<template>
<div>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="My Team"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <v-card flat class="transparent" v-if="loaded && user.team!=null">
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6">
                        <div class="d-flex align-center">
                            <GroupAvatar :photo="team.photo" size="100px" class="elevation-3"/>
                            <div class="ml-3">
                                <div class="display-1 font-weight-light black--text">{{team.name}}</div>
                                <div class="subtitle-1 font-weight-light black--text" style="line-height:1.2">
                                    <span v-if="team.bio">{{team.bio}}</span>
                                    <span v-else class="grey--text">Slogan Team missing</span>
                                    <span class="ml-2">
                                        <v-icon size="12px" color="accent" @click="showEditBio=true">fa-pen</v-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="12" sm="6">
                        <div class="text-right">
                            <div class="mt-n1 caption ml-1">{{team.str}}</div>
                            <div class="mt-n1 caption ml-1">{{team.reference}}</div>
                            <div class="mt-n1 caption ml-1">{{team.center.name}} Center</div>
                            <v-btn depressed class="accent" x-small @click="showDiagImage=true">
                                <span style="font-size:10px">Change image</span>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <SendingLoader v-if="!loaded"/>

        <div class="text-right" v-if="team.attributes && user.team!=null">
            <v-btn depressed class="accent" small @click="showDiagAttr=true">Edit your team attributes</v-btn>
        </div>

        <v-tabs v-model="tab" background-color="#fdfdfd" color="accent" v-if="loaded && user.team!=null">
            <v-tab class="font-weight-regular black--text">Members</v-tab>
            <v-tab class="font-weight-regular black--text">Documents</v-tab>
            <v-tab class="font-weight-regular black--text">Molecule</v-tab>

            <v-tab-item>
                <ListTeamUsers :items="items" />
            </v-tab-item>

            <v-tab-item>
                <ListTeamFilesShared :team="user.team" />
            </v-tab-item>

            <v-tab-item background-color="#fdfdfd">
                <v-card outlined v-if="team.attributes==undefined">
                    <v-card-text>
                        <div class="my-6 ml-2 ml-sm-12">
                           <v-btn depressed class="accent" @click="showDiagAttr=true">Edit your team attributes</v-btn>
                        </div>
                    </v-card-text>
                </v-card>
                
                <div v-if="team.attributes">
                    <Central
                        class="mt-4"
                        :photo="team.photo"
                        :name="team.name"
                        :attributes="team.attributes" />
                </div>
            </v-tab-item>
        </v-tabs>
	</v-card>

    <PhotoTeam 
        :model="showDiagImage" 
        :team="team"
        @cancel="showDiagImage=false"
        @close="reinit"
        v-if="loaded" />
    
    <DiagBio
        :model="showEditBio"
        :team="team"
        for="team"
        @cancel="showEditBio=false"
        @changed="reinit" />
    
    <DiagTeamAttributes
        :model="showDiagAttr"
        :team="team"
        @cancel="showDiagAttr=false"
        @changed="reinit" />
</div>
</template>

<script>
import Centers from '@/firebase/centers'
import ListTeamUsers from '@/components/myTeam/ListTeamUsers'
import Users from '@/firebase/users'
import Teams from '@/firebase/teams'
import Helpers from '@/services/helpers'
import PhotoTeam from '@/components/myTeam/PhotoTeam'
import DiagBio from '@/components/core/dialogs/DiagBio'
import ListTeamFilesShared from '@/components/myTeam/ListTeamFilesShared'
import Central from '@/components/molecule/Central'
import DiagTeamAttributes from '@/components/core/dialogs/DiagTeamAttributes'

export default {
    data: () => ({
        loaded: false,
        team: null,
        items: [],
        tab: 0,
        showDiagImage: false,
        showEditBio: false,
        showDiagAttr: false
    }),
    components: {
        ListTeamUsers,
        PhotoTeam,
        DiagBio,
        ListTeamFilesShared,
        Central,
        DiagTeamAttributes
    },
    mounted() {
        this.init();
    },
    methods: {
        reinit() {
            this.showDiagImage = false;
            this.showEditBio = false;
            this.showDiagAttr = false;
            this.loaded = false;
            this.init();
        },
        init() {
            Teams.get(this.user.team)
                    .then(response => {
                        if (response.status === true) {
                            this.team = response.doc.data();
                            this.team.id = response.doc.id;
                            this.team.str = this.team.group.day + ' / ' + this.team.group.hour;
                            this.getUsers();
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        getUsers() {
            Users.getTeamMates(this.user.team)
                    .then(response => {
                        if (response.status === true) {
                            this.items = Helpers.formatItems(response.query, 'uid');
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>
